import comp from "./RichTextEditor";
export default comp;
